<template>
  <div class="medicine">
    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Hospitais</h3>
        <h4>HIS</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img1"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>Pixeon smart</h4>
        <p>
          Gestão total e eficiente de todos os setores de um hospital. Com mais autonomia,
          você se dedica mais ao que realmente importa: o paciente.
        </p>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img2"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img3"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>Beira-Leito</h4>
        <p>
          Circuito fechado da administração de medicamentos
        </p>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img4"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Clínicas e centros médicos</h3>
        <h4>cIS</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img5"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>PIXEON smart</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.clinic.img6"
          />
        </figure>
      </el-col>
    </el-row>

    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'Clinic',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.medicine {
  img {
    width: 100%;
  }
}

.medicine-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $light-blue;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $light-blue;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}
</style>
